import client from '../utils/client';
// import { apiBaseUrl } from '../constants/configuration';
import { endPoints } from '../constants/configuration';
import { add } from 'lodash';

// all the apis can be called from here

// export const getConfigurationData = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.auth + '/config?action=list&type=all', {
//             headers: {
//                 common: {
//                     'torc_tenant': parseInt(tenantId),
//                     'torc_user': userId,
//                     'Authorization': `Bearer ${authToken}`
//                 }
//             }
//         }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getFilterListApi = async ({ tenantId, authToken, userId }) => {
    // const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
    // const authData = JSON.parse(localStorage.getItem('AuthData'));
    try {
        const { data } = await client({ druid: true, noCors: true }).get(
            // endPoints.ionReport + '/list/custom',
            'Custom?ion=true',
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getIonFilterListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).get(
            // endPoints.ionReport + '/list/ion/custom',
            'Custom?ionreport=true',
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const getPreSignInData = async preSignInReqBody => {
    try {
        const { data } = await client().post(
            endPoints.auth + `/oauth/v2/pre-signin?data=${preSignInReqBody}`,
            {}
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getSignInData = async signInReqBody => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/oauth/v2/signin',
            {},
            {
                params: { data: signInReqBody }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getReSignInData = async ({ reSignInReqBody, authToken }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/oauth/v2/re-signin',
            {},
            {
                params: { data: reSignInReqBody },
                headers: {
                    common: {
                        'Authorization': `Bearer ${authToken}`,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const logoutApi = async ({ logoutReqBody, authToken }) => {
    //BLOWFISHED API CALL

    try {
        const { data } = await client().post(
            endPoints.auth + '/oauth/v2/logout' + `?data=${logoutReqBody}`, {},
            {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }


    // OLD API CALL
    // try {
    //     const { data } = await client().post(
    //         endPoints.auth + '/oauth/logout', logoutReqBody,
    //         {
    //             headers: {
    //                 common: {
    //                     'Authorization': `Bearer ${authToken}`,
    //                 }
    //             }
    //         }
    //     );
    //     return data;
    // } catch (error) {
    //     // get axios errors from error.response
    //     console.log(error);
    //     throw error;
    // }
}

// ---* ION * ---

// * adUnitApi *
// export const getAdUnitListApi = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.adunit + '?listaddunit=all',
//             {
//                 headers: {
//                     common: {
//                         'tai_tenant': parseInt(tenantId),
//                         'tai_token': authToken,
//                         'tai_user': userId,
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }


export const getAdUnitListApi = async ({ tenantId, authToken, userId, tenantList, params = {} }) => {
    let x = '';
    let y = '';
    let z = 'd'
    if (tenantList) {
        x = '&acclist=';
        y = 'acc';
        z = '';
        let flag = true;
        for (let i = 0; i < tenantList.length; i++) {
            if (flag) {
                x += tenantList[i];
                flag = false;
            } else {
                x += ',' + tenantList[i]
            }
        }
    }
    try {
        const { data } = await client().get(
            // 'localhost:9091/adunit?listaccadunit=all&acclist=28,2
            //                 /adunit?listaccaddunit=all&acclist=240
            endPoints.adunit + `?list${y}ad${z}unit=all${x}`,
            // endPoints.adunit + `?listaccadunit=all&acclist=28`,
            {
                params: params,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const editAdUnitApi = async ({ tenantId, authToken, userId, editId }) => {
    try {
        const { data } = await client().get(
            endPoints.adunit,
            {
                params: editId,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addAdUnitApi = async ({ tenantId, authToken, userId, adUnitReqBody, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.adunit, adUnitReqBody, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addBulkAdUnitApi = async ({ tenantId, authToken, userId, adUnitReqBody, addParams }) => {
    try {
        const { data } = await client({ multipart: false }).post(endPoints.adunit, adUnitReqBody, {
            params: addParams,
            headers: {
                common: {
                    'Content-Type': "multipart/form-data",
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        },
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteAdUnitApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.adunit, {
            params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// ad unit downloadApi **************************
export const downloadAddUnitApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            `${endPoints.adunit}?download=list`, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// * AdUnit Group Api *
export const addAdUnitGroupApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.adgroup, payload, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addBulkAdUnitGroupApi = async ({ tenantId, authToken, userId, FilePayload, addParams }) => {
    try {
        // http://localhost:9091/adgroup?addupadgroup=bulkaddupadgroup&active=1&adGroupName=TestArjun18
        const { data } = await client({ multipart: false }).post(endPoints.adgroup, FilePayload, {
            params: addParams,
            headers: {
                common: {
                    'Content-Type': "multipart/form-data",
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        },
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const getAdUnitGroupListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.adgroup + '?listadgroup=all',
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getAddUnitSearchApi = async ({ tenantId, authToken, userId, params }) => {
    try {
        const { data } = await client().get(
            endPoints.adgroup + `?type=adunit&srchstr=${params}`,
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteAdUnitGroupApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.adgroup,
            {
                params: deleteId,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// //  * Private Market Place *
export const getPMPListApi = async ({ tenantId, authToken, userId, params = "auto", Addparams }) => {
    try {
        const { data } = await client().get(
            endPoints.pmp + `?listpmp=${params}`,
            {
                params: Addparams,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// //  * Private Market Place List Filter *
export const getPMPListFilterApi = async ({ tenantId, authToken, userId, Addparams, payload = {} }) => {
    try {
        const { data } = await client().post(
            endPoints.pmp,
            payload,
            {
                params: Addparams,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getRoadblockListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.pmp + '?listpmp=roadblock',
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addRoadblock = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.pmp, payload, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addPMPApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.pmp, payload, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deletePMPApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.pmp, {
            params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// Add Mediation AdGroup

export const getMediationAdGroupListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.mediation + '?listadgroup=all',
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const getMediationSearchApi = async ({ tenantId, authToken, userId, params }) => {
    try {
        const { data } = await client().get(
            endPoints.mediation + `?listadgroup=${params}`,
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const addMediationAdGroupListApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.mediation, payload,
            {
                params: addParams,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteMediationAdGroupApi = async ({ tenantId, authToken, userId, addParams }) => {
    try {
        const { data } = await client().get(
            endPoints.mediation,
            {
                params: addParams,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// mediation  api

export const getMediationApi = async ({ tenantId, authToken, userId, params }) => {
    try {
        const { data } = await client().get(
            endPoints.mediation + '?listmediationt=all', {
            params: params,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const addMediationApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.mediation, payload, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteMediationApi = async ({ tenantId, authToken, userId, addParams }) => {
    try {
        const { data } = await client().get(
            endPoints.mediation, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// * Tagld Mapping *
export const getTagldMappingListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.adUnitMap + '?list=all',
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const getTagldMappingDownloadCSVApi = async ({ tenantId, authToken, userId, downloadCSV }) => {
    try {
        const { data } = await client().get(
            endPoints.adUnitMap,
            {
                params: downloadCSV,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteTagMapApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.adUnitMap, {
            params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getTagldMappingListadunitAllApi = async ({ tenantId, authToken, userId, getId }) => {
    try {
        const { data } = await client().get(
            endPoints.adUnitMap + '?listadunit=all',
            {
                params: getId,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const tagldMappingAddAdunitmapApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.adUnitMap, payload,
            {
                params: addParams,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// bulk upload
export const uploadSiteFileBulkCSVApi = async ({ tenantId, authToken, userId, payload }) => {
    try {
        const { data } = await client({ multipart: false }).patch(endPoints.adUnitBulk + `?bulkadd=auto`, payload
            ,
            {
                headers: {
                    common: {
                        'Content-Type': "multipart/form-data",
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            },
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const gettagldMappingBulkListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.adUnitBulk + '?list=all',
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const tagldMappingBulkDownloadApi = async ({ tenantId, authToken, userId, downloadObj }) => {
    try {
        const { data } = await client().get(
            endPoints.adUnitBulk,
            {
                params: downloadObj,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


// admin Supply Partner List Api
export const getAdminSupplypartnerListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/supplypartner/Torcai?action=list',
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// dashboard api ion
export const getMediaReportApi = async ({ tenantId, authToken, userId, mediaReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.ionReport + '/mediareport', mediaReportReqBody, {
            '/media', mediaReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const getQpsReportApi = async ({ tenantId, authToken, userId, qpsReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.ionReport + '/qps', qpsReportReqBody, {
            '/QPS', qpsReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getRevenueReportApi = async ({ tenantId, authToken, userId, revenueReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.ionReport + '/billingreport', revenueReportReqBody, {
            '/Revenue', revenueReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getIonExchangeApi = async ({ tenantId, authToken, userId, ionExchangeReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.ionReport + '/ionreport', ionExchangeReqBody, {
            '/excion', ionExchangeReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getIonExchangeDownloadApi = async ({ tenantId, authToken, userId, ionExchangeReqBodyDownload }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.ionReport + '/ionreport?action=Download', ionExchangeReqBodyDownload, {
            '/excion?action=Download', ionExchangeReqBodyDownload, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}




export const getIonExchangeSupplyPartnerListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).get(
            endPoints.ionReport + '/list/custom?filter=supplypartner', {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const getAdminTenantSupplypartnerListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/supplypartner/Torcai?action=tenantlist',
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// admin Variable  Api
// export const getAdminVariableListApi = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.auth + '/saveupdate/Torcai?type=attributes&action=list',
//             {
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getAdminVariableListApi = async ({ tenantId, authToken, userId, params = {} }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/config?action=list&type=all',
            {
                params,
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// export const addAdminVariableApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
//     try {
//         const { data } = await client().post(
//             endPoints.auth + '/saveupdate/Torcai?type=attributes', payload,
//             {
//                 params: addParams,
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const addAdminVariableApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/config?action=addup&type=attributes', [payload],
            {
                // params: addParams,
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }

}


export const getUserReachReportApi = async (tenantId, authToken, userId, campaignPerformanceReportReqBody) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + '/userreach?list', campaignPerformanceReportReqBody, {
            '/UserReach', campaignPerformanceReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// admin User  Api
export const getAdminUserListApi = async ({ addParams, tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/user?list=all',
            {
                params: addParams,
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getAdminUserSingleListApi = async ({ tenantId, authToken, userId, id }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/user?list=' + id,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addAdminUserApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/user?addup=' + addParams, payload,
            {
                // params: addParams,
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


// admin Roles Api
export const getRolesListApi = async ({ tenantId, authToken, userId, addParams = 'byuser', params }) => {
    try {
        if (Number(params) > 0) {
            addParams = `byplatform&id=${params}`
        }
        const { data } = await client().get(
            endPoints.auth + '/role?list=' + addParams,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );

        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const postFilterRolesListApi = async ({ tenantId, authToken, userId, addParams, payload }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/role?list=' + addParams,
            payload,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );

        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getAdminRoleSingleListApi = async ({ tenantId, authToken, userId, id }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/role?list=' + id,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addAdminRolesApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            // endPoints.auth + '/saveupdate/Torcai?type=role', payload,
            endPoints.auth + '/role', payload,
            {
                params: addParams,
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}



export const getDemandpartnerSeatListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/agreement?action=demandseat',
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
// mediation demandpartner list
export const getMediationDemandpartnerSeatListApi = async ({ tenantId, authToken, userId, mediationId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/agreement?action=demandpartners&type=' + mediationId,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
// admin currency rate list
export const getCurrencyRateListApi = async ({ tenantId, authToken, userId, addParams, payload }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/currency?list=' + addParams,
            payload,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const addCurrencyRateApi = async (tenantId, authToken, userId, payload) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/currency?addup=auto', payload,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );

        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
// admin Demand Partner  List Api

export const getDemandpartnerListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/demandpartner/Torcai?action=list',
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addAdminDemandPartnerApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/demandpartner/Torcai', payload,
            {
                params: addParams,
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getDemandPartnerNamesFilterApi = async ({ tenantId, authToken, userId, addParams }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/demandpartner/Torcai?action=getids',
            {
                params: addParams,
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getTenantDemandpartnerListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/demandpartner/Torcai?action=tenantlist',
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}




// admin agreement List Api
export const getAgreementListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/agreement?action=list',
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        throw error;
    }
}


export const addAdminAgreementApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/agreement', payload,
            {
                params: addParams,
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getAgreementConnectionListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/connection?action=list',
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        throw error;
    }
}

export const getAgreementActiveSeatListApi = async ({ tenantId, authToken, userId, param }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + `/supplypath?action=activeseat&type=${param}`,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        throw error;
    }
}
export const getPvtExchangeTenantListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + `/tenant?list=isprimary`,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        throw error;
    }
}
export const getPvtDemandPartnerListApi = async ({ tenantId, authToken, userId, param }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + `/demandpartner?action=list&id=${param}`,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        throw error;
    }
}
// export const addAdminAgreementApi = async ({ tenantId, authToken, userId,  deleteId }) => {
//     try {
//         const { data } = await client().post(
//             '/authentication/agreement?action=delete', payload,
//             {
//                 params: deleteId,
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }


// admin Supplypath List Api
export const getIONSupplypathListApi = async ({ tenantId, authToken, userId, param }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + `/supplypath?action=${param}`,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        throw error;
    }
}

export const getPVTSupplypathListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/agreement?action=list',
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        throw error;
    }
}


export const updateIONSupplypathApi = async ({ tenantId, authToken, userId, payload }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/supplypath?action=update', payload,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const updatePvtSupplypathApi = async ({ tenantId, authToken, userId, param, payload }) => {
    try {

        const { data } = await client().post(
            endPoints.auth + `/agreement?action=updatepath&id=${param}`, payload,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const postCuratedApi = async ({ tenantId, authToken, userId, payload={}, params={} }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + `${endPoints.curated}/Torcai`, payload, {
            params,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const getCuratedApi = async ({ tenantId, authToken, userId, params={} }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + `${endPoints.curated}/Torcai`,{
            params,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}



// ---- *  Bidder api call * -------

export const getBidderReportApi = async ({ tenantId, authToken, userId, bidderReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + '/bidderreport', bidderReportReqBody, {
            '/bidder', bidderReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
//----userReach-------------
// export const getUserReachReportApi = async (tenantId, authToken, userId, campaignPerformanceReportReqBody) => {
//     try {
//         const { data } = await client().post(
//             endPoints.bidder + '/userreach?list', campaignPerformanceReportReqBody, {
//             headers: {
//                 common: {
//                     'tai_tenant': parseInt(tenantId),
//                     'tai_token': authToken,
//                     'tai_user': userId,
//                 }
//             }
//         }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

//---mediaPlanning report Api call--------


export const getMediaSaveReportApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + '/scheduledreport?list=all', { "filters": { "reportType": 2 } }, {
            '/savereport?list=all', { "filters": { "reportType": 2 } }, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        // const { data } = await client().get(
        //     endPoints.bidder + '/mediascheduledreport?action=list', {
        //     headers: {
        //         common: {
        //             'tai_tenant': parseInt(tenantId),
        //             'tai_token': authToken,
        //             'tai_user': userId,
        //         }
        //     }
        // }
        // );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const getMediaPlanningReportApi = async ({ tenantId, authToken, userId, mediaPlanningReportReqBody }) => {
    try {

        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + '/mediaplanning', mediaPlanningReportReqBody, {
            '/mpr', mediaPlanningReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getGenerateReportApi = async ({ tenantId, authToken, userId, mediaPlanningReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + "/scheduledreport?addup=auto", mediaPlanningReportReqBody, {
            "/savereport?addup=auto", mediaPlanningReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        // let a = {
        //     "responeCode": {
        //         "status": "success",
        //         "code": 200,
        //         "msg": ""
        //     },
        //     "response": [
        //         {
        //             "os": "linux",
        //             "totalRequest": 12,
        //             "eCPM": 200.0000,
        //             "maxBid": 100.0000,
        //             "avgBidFloor": 5.0000,
        //             "totalBusinessReq": 20
        //         }]
        // }
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const getRefreshReportApi = async ({ tenantId, authToken, userId, rowId, payload }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + "/scheduledreport?action=" + rowId, payload, {
            // "/savereport?action=" + rowId, payload, {
            "/savereport?refresh=" + rowId, payload, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// ---- *  CampaignPerformance api call * -------

export const getCampaignPerformanceReportApi = async ({ tenantId, authToken, userId, campaignPerformanceReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + '/campaignreport', campaignPerformanceReportReqBody, {
            '/campaignperformance', campaignPerformanceReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const addSaveReportApi = async ({ tenantId, authToken, userId, payload }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + '/scheduledreport?addup=auto', payload, {
            '/savereport?addup=auto', payload, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const refreshSaveReportApi = async ({ tenantId, authToken, userId, payload, id }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + `/scheduledreport?action=${id}`, payload, {
            `/savereport?action=${id}`, payload, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getCampaignPerformanceReportFilterListApi = async ({ tenantId, authToken, userId }) => {
    try {

        const { data } = await client({ druid: true, noCors: true }).get(
            // endPoints.bidder + '/custom', 
            'Custom?bidder=true',
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getSaveReportApi = async ({ tenantId, authToken, userId, type }) => {
    try {

        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + '/scheduledreport?list=all', { "filters": { "reportType": type } }, {
            '/savereport?list=all', { "filters": { "reportType": type } }, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getSaveReportDownloadApi = async ({ tenantId, authToken, userId, param }) => {
    try {
        const { data } = await client().get(
            endPoints.bidder + "/scheduledreport?download=" + param, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const getCampaignListAllReportApi = async ({ tenantId, authToken, userId, payload, params }) => {
    try {
        const { data } = await client().post(
            endPoints.campaign + '?list=all', payload, {
            params: params,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getCampaignEditIdReportApi = async ({ tenantId, authToken, userId, editId }) => {
    try {
        const { data } = await client().get(
            endPoints.campaign, {
            params: editId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// campaign  Private Market Place 

export const getPrivateMarketPlaceApi = async ({ tenantId, authToken, userId, params }) => {
    try {
        const { data } = await client().get(
            endPoints.campaignPmp + '?list=all', {
            params: params,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addPrivateMarketPlaceApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.campaignPmp, payload, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deletePrivateMarketPlaceApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.campaignPmp, {
            params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


// ---- * Io * --------
export const getIoListAllReportApi = async ({ tenantId, authToken, userId, params, payload = {} }) => {
    try {
        const { data } = await client().post(
            endPoints.io + '?list=all', payload, {
            params: params,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                },
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}



export const addIoReportApi = async ({ tenantId, authToken, userId, addIoReqBody, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.io, addIoReqBody, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getIoAdvertisersReportApi = async ({ tenantId, authToken, userId, tenantType }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/tenant?list=bytype', {
            params: tenantType,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteIoApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.io, {
            params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const getIoEditIdReportApi = async ({ tenantId, authToken, userId, editId, ioTenantId }) => {
    let x = ''
    if (editId && editId.list) {
        x = `?list=${editId.list}`;
    }
    try {
        const { data } = await client().post(endPoints.io + x, ioTenantId, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        });
        // console.log(editId);
        // const { data } = await client().post(
        //     endPoints.io, {
        //     params: editId,
        //     // data: ioTenantId,
        //     headers: {
        //         common: {
        //             'tai_tenant': parseInt(tenantId),
        //             'tai_token': authToken,
        //             'tai_user': userId,
        //         }
        //     }
        // }
        // );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// ---- * Country/state/city * ----

export const getCountryListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(endPoints.geo + '?type=country', {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getStateListApi = async ({ tenantId, authToken, userId, countryCode = '' }) => {
    try {
        const { data } = await client().get(
            endPoints.geo + '?type=state', {
            params: countryCode,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        },
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getCityListApi = async ({ tenantId, authToken, userId, cncode = '', scode = '' }) => {
    let cnscCode;
    if (cncode || scode) {
        cnscCode = { cncode, scode }
    }
    try {
        const { data } = await client().get(
            endPoints.geo + '?type=city', {
            params: cnscCode,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


// ------* Campaign * -------

// export const getCampaignSubCategoryReportApi = async ({ valueId }, token) => {
//     try {
//         const { data } = await client().get(endPoints.auth + '/attribute/Torcai', {
//             params: valueId,
//             headers: {
//                 common: {
//                     'torc_tenant': parseInt(token.tenantId),
//                     'torc_user': token.userId,
//                     'Authorization': `Bearer ${token.authToken}`
//                 }
//             }
//         });
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getCampaignSubCategoryReportApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        if (payload.list.length == 1) {
            payload.list.push(-1)
        }
        const { data } = await client().get(
            endPoints.auth + `/config?action=list&type=${payload.list.join(',')}&value=child`, {
            params: addParams,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        let arr = [];
        if (payload.list.length > 1) {
            Object.keys(data.responseList[0]).forEach(key => {
                arr = [...arr, ...data.responseList[0][key].map((item) => ({ ...item, categoryId: key }))]
            })
            data.responseList = arr;
        }
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addCampaignApi = async ({ tenantId, authToken, userId, addCampaignBody, editId }) => {
    try {
        const { data } = await client().post(
            endPoints.campaign, addCampaignBody, {
            params: editId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getAdvertiserCreativeGroupApi = async ({ tenantId, authToken, userId, advertiserId }) => {
    try {
        const { data } = await client().post(endPoints.creative + '?list=all ', { advertiserId }, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteCampaignApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.campaign, {
            params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getCampaignCategoryTypeApi = async ({ tenantId, authToken, userId }) => {
    try {
        // const { data } = await client().get(endPoints.auth + '/config/Torcai?type=CAMPAIGN_CATEGORY_TYPE',
        const { data } = await client().get(endPoints.auth + '/config?action=list&type=CAMPAIGN_CATEGORY_TYPE',
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// export const getCampaignCategoryTypeApi = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(endPoints.auth + '/category?category=1',
//             {
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             });

//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }
//  trouble shooter api
export const getStrategyBudgetDataApi = async ({ tenantId, authToken, userId, payload }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post('/troubleFirst', payload,
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const getStrategyBudgetSpendDataApi = async ({ tenantId, authToken, userId, payload, isDownload }) => {
    try {
        let url = `/troubleSecond${isDownload ? '?action=download' : ''}`
        const { data } = await client({ druid: true, noCors: true }).post(url, payload,
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const getDayPartDataForTrobleShooter = async ({ tenantId, authToken, userId, payload }) => {
    try {
        let url = `${endPoints.campaign}?dayPart=true`;
        console.log(url)
        const { data } = await client().post(url, payload,
            {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// ---*  Creative * ---
export const addCreativeApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(endPoints.creative, payload, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getUserReachReportDownloadApi = async ({ tenantId, authToken, userId, userReachReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            '/UserReach?action=download', userReachReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteCreativeApi = async ({ tenantId, authToken, userId, deleteId, advertiserId }) => {
    try {
        const { data } = await client().post(
            endPoints.creative, advertiserId, {
            params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const editCreativeApi = async ({ tenantId, authToken, userId, advertiserId, editId }) => {
    try {
        const { data } = await client().post(
            endPoints.creative, advertiserId, {
            params: editId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

/* common api */

export const vastValidatorApi = async ({ tenantId, userId, authToken, url }) => {
    try {
        const { data } = await client().get(
            endPoints.vastValidator + `?url=${url}`, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const uploadFileActionApi = async ({ payload, advertiserId, accept, size }) => {
    let flag = true, height = '', width = '';
    console.log(size, "size");
    if (size) {
        for (let i = 0; i < size.length; i++) {
            if (flag) {
                if (size.charAt(i) === 'x' || size.charAt(i) === 'X') {
                    flag = false;
                } else {
                    width += size.charAt(i);
                }
            } else {
                height += size.charAt(i);
            }
        }
    }

    try {
        const { data } = await client({ multipart: true }).patch(`/upload`, payload, {
            params: {
                advertiserId,
                type: accept,
                height,
                width
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const uploadPlatformFileActionApi = async ({ payload, advertiserId, accept }) => {
    try {
        console.log(payload)
        const { data } = await client({ multipart: true }).patch(`/upload-logo`, payload, {
            params: {
                advertiserId,
                type: accept
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const uploadSupplyPartnerFileActionApi = async ({ payload, advertiserId, accept }) => {
    try {
        const { data } = await client({ multipart: true }).patch(`/upload-txt`, payload, {
            params: {
                advertiserId,
                type: accept
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const getDownloadDomainListApi = async ({ tenantId, authToken, userId, spId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/supplypartner/Torcai?action=download&id=' + spId, {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
// ---- * Admin * ----

// * Tenant api *
export const getTenantApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/tenant?list=all', {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addTenantApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        console.log(addParams);
        let isAdd = (addParams.action === "create") ? "auto" : payload.tenantId;
        const { data } = await client().post(
            endPoints.auth + `/tenant?addup=${isAdd}`, payload, {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteTenantApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/saveupdate/Torcai?type=tenant&action=delete', {
            params: deleteId,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const editTenantApi = async ({ tenantId, authToken, userId, editId, mgrData }) => {
    try {
        let param = editId
        if (mgrData) {
            param = `${editId}&parameter=${mgrData}`
        }
        const { data } = await client().get(
            endPoints.auth + `/tenant?list=${param}`, {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

//http://localhost:9095/authentication/tenant/Torcai?type=tenant&tenantId=4"

// * SupplyPartner  *

// export const getSupplyPartnerApi = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.auth + '/supplypartner/Torcai?action=list', {
//             headers: {
//                 common: {
//                     'torc_tenant': parseInt(tenantId),
//                     'torc_user': userId,
//                     'Authorization': `Bearer ${authToken}`
//                 }
//             }
//         }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getSupplyPartnerApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/supplypartner/Torcai?action=list', {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addSupplyPartnerApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/supplypartner/Torcai', payload, {
            params: addParams,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteSupplyPartnerApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/supplypartner/Torcai?action=delete', {
            params: deleteId,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const editSupplyPartnerApi = async ({ tenantId, authToken, userId, editId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/supplypartner/Torcai?action=get', {
            params: editId,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// ----* Features *----
// export const getListFeatureApi = async ({ tenantId, authToken, userId, type }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.auth + '/feature', {
//             params: type,
//             headers: {
//                 common: {
//                     'torc_tenant': parseInt(tenantId),
//                     'torc_user': userId,
//                     'Authorization': `Bearer ${authToken}`
//                 }
//             }
//         }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getListFeatureApi = async ({ tenantId, authToken, userId, type }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/feature', {
            params: type,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// export const getFeatureListApi = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.auth + '/saveupdate/Torcai?type=feature&action=list', {
//             headers: {
//                 common: {
//                     'torc_tenant': parseInt(tenantId),
//                     'torc_user': userId,
//                     'Authorization': `Bearer ${authToken}`
//                 }
//             }
//         }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getFeatureListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/feature?action=list&type=featuredetail', {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// export const addFeatureApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
//     try {
//         const { data } = await client().post(
//             endPoints.auth + '/saveupdate/Torcai?type=feature', payload
//             , {
//                 params: addParams,
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const addFeatureApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/feature?type=featuredetail', payload
            , {
                params: addParams,
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// export const addFeatureAttributeApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
//     try {
//         const { data } = await client().post(
//             endPoints.auth + '/feature/Torcai', payload
//             , {
//                 params: addParams,
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const addFeatureAttributeApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/feature/Torcai', payload
            , {
                params: addParams,
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const roleAccessPermissions = async ({ tenantId, authToken, userId, userType = 'byuser' }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/role?list=' + userType,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


// ---- * Audience * ----

// * Apr api *
export const getAprApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/apr/list', {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addAprApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.data + `/apr/${addParams}`, payload, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getAprEditApi = async ({ tenantId, authToken, userId, editId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/apr/get?', {
            params: editId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const aprDownloadApi = async ({ tenantId, authToken, userId, aprId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/apr/download?id=' + aprId, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


// export const getSegmentListApi = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(endPoints.data + '/segment?list=all', {
//             headers: {
//                 common: {
//                     'tai_tenant': parseInt(tenantId),
//                     'tai_user': userId,
//                     'tai_token': `${authToken}`
//                 }
//             }
//         });
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getSegmentListApi = async ({ tenantId, authToken, userId, params, Addparams }) => {
    let a = '';
    if (params == 'custom') {
        a = `&type=custom`;

    } else if (params == 'unclassified') {
        a = `&type=unclassified`;
    }
    try {
        const { data } = await client().get(
            // endPoints.data + '/segment?list=all', 
            endPoints.data + `/segment?list=all` + (params != " " ? a : ""),
            {
                params: Addparams,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_user': userId,
                        'tai_token': `${authToken}`
                    }
                }
            });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getHierarchyListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(endPoints.data + '/hierarchy?list=all', {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}



export const addHierarchyApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.data + '/hierarchy?addup=' + addParams, payload, {
            // params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteHierarchyApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/hierarchy?delhierarchy=' + deleteId, {
            // params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const addSegmentApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.data + '/segment?addup=' + addParams, payload, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getDataPixelEditApi = async ({ tenantId, authToken, userId, editId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/audience/Torcai?', {
            params: editId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// DataCaptureApi
export const addDataCaptureApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.data + '/audience/Torcai', payload, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getDataCaptureApi = async ({ tenantId, authToken, userId, editId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/audience/Torcai', {
            params: editId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getDataCaptureListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/audience/Torcai?list=all', {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteDataCaptureApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/audience/Torcai', {
            params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getsegmentEditApi = async ({ tenantId, authToken, userId, editId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/segment?', {
            params: editId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// audiance Hierarchy

export const getAudhierarchyListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(endPoints.data + '/hierarchy?audhierarchylist=all', {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const downloadingConversionTagApi = async ({ tenantId, authToken, userId, dwnldpxlsId }) => {
    try {
        const { data } = await client().get(endPoints.data + '/audience/Torcai', {
            params: dwnldpxlsId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const getAudiancePixelMicrosApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(endPoints.auth + '/config/Torcai?type=AUD_PXL_MACROS&action=list', {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// DataCaptureApi
export const checkTagAndPostbackuniqueApi = async ({ tenantId, authToken, userId, checkParam }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/audience/Torcai', {
            params: checkParam,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

/* common api */
export const uploadScriptApi = async ({ tenantId, authToken, userId, payload }) => {
    try {
        const { data } = await client({ multipart: true })
            .patch('/upload-js', payload, {
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getPinCodeListApi = async ({ tenantId, authToken, userId, cncode, scode, ccode }) => {
    let cnscnccCode;
    if (cncode || scode || ccode) {
        cnscnccCode = { cncode, scode, ccode };
    }
    try {
        const { data } = await client().get(
            endPoints.geo + '?type=pincode',
            {
                params: cnscnccCode,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// reset password
export const forgotPasswordApi = async (authUser) => {
    try {
        const { data } = await client().post(
            endPoints.auth + '/oauth/fp', '', {
            headers: {
                common: {
                    'auth_user': authUser
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }

}

export const validateResetPasswordApi = async ({ rp }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/oauth/ufp?rp=' + rp,
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }

}

export const changePasswordApi = async ({ password, rp }) => {
    // 'authentication/oauth/cp?password=' + password + '&rp=' + rp, '', {
    try {
        const { data } = await client().post(
            endPoints.auth + '/oauth/v2/cp?data=' + password + '&rp=' + rp, '', {
            // headers: {
            //     common: {
            //         'auth_user': authUser
            //     }
            // }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }

}

// * campaign screen site list *
export const getCampaignSiteApi = async ({ tenantId, authToken, userId, payload }) => {
    try {
        const { data } = await client().post(
            endPoints.medialist + '?list=all', payload, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// upload site file

export const uploadSiteFileApi = async ({ payload }) => {
    try {
        const { data } = await client({ multipart: true }).patch(`/upload-site`, payload, {
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addCampaignSiteApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
    try {
        const { data } = await client().post(
            endPoints.medialist, payload, {
            params: addParams,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteCampaignSiteApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.medialist, {
            params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getCampaignPerformanceReportDownloadApi = async ({ tenantId, authToken, userId, campaignPerformanceReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + '/campaignreport?action=Download', campaignPerformanceReportReqBody, {
            '/campaignperformance?action=Download', campaignPerformanceReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getBidderReportDownloadApi = async ({ tenantId, authToken, userId, bidderReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + '/bidder?action=Download', bidderReportReqBody, {
            '/bidder?action=Download', bidderReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getMediaPlanningDownloadReportApi = async ({ tenantId, authToken, userId, mediaPlanningReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.bidder + '/mediaplanning?action=Download', mediaPlanningReportReqBody, {
            '/mpr?action=Download', mediaPlanningReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getMediaReportDownloadApi = async ({ tenantId, authToken, userId, mediaReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.ionReport + '/mediareport?action=Download', mediaReportReqBody, {
            '/media?action=Download', mediaReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const SaveMediaReportApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // '/savereport?list=all', { "reportType": 3 } , {
            '/savereport?list=all', { "filters": { "reportType": 3 } }, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );

        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getRevenueReportDownloadApi = async ({ tenantId, authToken, userId, revenueReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.ionReport + '/billingreport?action=Download', revenueReportReqBody, {
            '/Revenue?action=Download', revenueReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getQpsReportDownloadApi = async ({ tenantId, authToken, userId, qpsReportReqBody }) => {
    try {
        const { data } = await client({ druid: true, noCors: true }).post(
            // endPoints.ionReport + '/qps?action=Download', qpsReportReqBody, {
            '/QPS?action=Download', qpsReportReqBody, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getCampaignPixelListApi = async ({ tenantId, authToken, userId, advertiserId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/audience/Torcai?list=' + advertiserId, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const deleteSegmentApi = async ({ tenantId, authToken, userId, deleteId }) => {
    try {
        const { data } = await client().get(
            endPoints.data + '/segment', {
            params: deleteId,
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_token': authToken,
                    'tai_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const editUpTenantApi = async (tenantId, authToken, userId, data, addParams, id, type) => {
    console.log(data);
    try {
        // let isAdd = (addParams.action === "create") ? "auto" : id;
        const { x } = await client().post(
            `/map/tenant?${addParams.action}=account&id=${id}`, data, {
            // param: response,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': authToken
                }
            }
        }
        );
        return x;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


export const addUpTenantApi = async (tenantId, authToken, userId, response, payload, type) => {
    try {
        // let isAdd = (addParams.action === "create") ? "auto" : id;
        const { data } = await client().post(
            `/map/tenant?addup=${type}&id=${response}`, payload, {
            // param: response,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const getAccountsListApi = async (tenantId, authToken, userId) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/account?list=all', {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'Authorization': `Bearer ${authToken}`,
                    'torc_user': userId,
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const addAccountApi = async ({ tenantId, authToken, userId, payload, addParams, id }) => {
    try {
        console.log(addParams);
        let isAdd = (addParams.action === "create") ? "auto" : id;
        const { data } = await client().post(
            endPoints.auth + `/account?addup=${isAdd}`, payload, {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const editAccountApi = async ({ tenantId, authToken, userId, editId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + `/account?list=${editId}`, {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const addPlatformApi = async ({ tenantId, authToken, userId, payload, addParams }) => {

    try {
        const { data } = await client().post(
            endPoints.auth + '/platform', payload, {
            params: addParams,
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const editPlatformApi = async ({ tenantId, authToken, userId, editId }) => {
    try {
        // const { data } = await client().get(
        //     endPoints.auth + '/platform', {
        //     params: editId,
        //     headers: {
        //         common: {
        //             'torc_tenant': parseInt(tenantId),
        //             'torc_user': userId,
        //             'Authorization': `Bearer ${authToken}`
        //         }
        //     }
        // }
        // );
        let a = { "responseCode": { "msg": "platform updated successfully", "status": "Success", "code": 2006 } }
        return a;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getPlatformListApi = async ({ tenantId, authToken, userId }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/platform?list=all&type=platform', {
            headers: {
                common: {
                    'torc_tenant': parseInt(tenantId),
                    'torc_user': userId,
                    'Authorization': `Bearer ${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

export const getPlatformSingleListApi = async ({ tenantId, authToken, userId, id }) => {
    try {
        const { data } = await client().get(
            endPoints.auth + '/platform?list=' + id,
            {
                headers: {
                    common: {
                        'torc_tenant': parseInt(tenantId),
                        'torc_user': userId,
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


//SEGMENT NEW API

export const getNewSegmentListApi = async ({ tenantId, authToken, userId, hierarchyVar, parentVar, grandVar, type }) => {
    let a = '';
    if (type == 'segment') {
        a = `${hierarchyVar}&parent=${parentVar}`;
        if (grandVar != '') {
            a = `${hierarchyVar}&parent=${parentVar}&grand=${grandVar}`;
        }
    } else {
        a = hierarchyVar;
    }
    try {
        const { data } = await client().get(endPoints.data + `/segment?list=part&hierarchy=${a}`, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

// Campaign->geoloaction->bulkpincode upload *****************************************************

export const bulkPincodeUploadCampaign = async ({ tenantId, authToken, userId, payload }) => {
    try {
        const { data } = await client().post(
            // &event=validate'
            endPoints.geo + `?type=pincode&event=validate`, payload, {
            // endPoints.geo + `?type=pincode&srch=pincodeBulkUpload`, payload, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}


// --------- Audience Hierarchy Download------------

export const audienceHierarchyDownloadCSVApi = async ({ tenantId, authToken, userId, hierarchy }) => {
    try {
        console.log("hierarchy", hierarchy)
        const { data } = await client().get(
            endPoints.data + `/segment?download=${hierarchy}`,
            {
                // params: hierarchy,
                headers: {
                    common: {
                        'tai_tenant': parseInt(tenantId),
                        'tai_token': authToken,
                        'tai_user': userId,
                    }
                }
            }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

//----------------------Alert API-----------------
export const getAlertListApi = async ({ tenantId, authToken, userId, params }) => {
    try {
        const { data } = await client().get(
            endPoints.alerts + `?list=${params}`, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
// siteListCSVDataApi
export const siteListCSVDataApi = async (payload) => {
    console.log(payload);
    try {
        const { data } = await client({ multipart: true }).patch(`/site-list-data`, payload, {
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}
export const getAlertDeleteApi = async ({ tenantId, authToken, userId, params }) => {
    try {
        const { data } = await client().get(
            endPoints.alerts + `?close=${params}`, {
            headers: {
                common: {
                    'tai_tenant': parseInt(tenantId),
                    'tai_user': userId,
                    'tai_token': `${authToken}`
                }
            }
        }
        );
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
}

